self.addEventListener('fetch', () => {})
